export const transitions = (property: string) => ({
  hover: `${property} 150ms cubic-bezier(0, 0, 0.3, 1)`,
});
